import { useContext, useEffect, useState } from 'react'

import { Autocomplete, Box, Spinner, Text } from '@fairfashion/design-system'
import { useNavigate, useParams } from 'react-router-dom'

import { BackButton } from '../../components/BackButton/back-button.comp'
import { ICompanyProvidersResponseDTO } from '../../sdk/company/company.types'
import { docMask, isCNPJ } from '../../utilities/masks/brasilianDocuments'

import { InvoiceCodeTable } from './components/InvoiceCodesTable/invoice-codes-table.comp'
import {
  OriginInvoiceContext,
  OriginInvoiceProvider,
} from './origin-invoice.context'

const OriginInvoiceComp = () => {
  const params = useParams()
  const navigate = useNavigate()

  const [provider, setProvider] = useState<ICompanyProvidersResponseDTO>()
  const [filter, setFilter] = useState('')

  const { providers, loading, actions } = useContext(OriginInvoiceContext)

  useEffect(() => {
    actions.getProviders(filter)
  }, [params, filter])

  const handleProviderChange = (provider: ICompanyProvidersResponseDTO) => {
    provider ? navigate(`/invoices/${provider.taxId}`) : navigate(`/invoices/`)
  }

  useEffect(() => {
    const provider = providers.find(
      (provider) => provider.taxId === params.providerTaxId,
    )

    if (provider) {
      setProvider(provider)
    }
  }, [providers])

  const getOptionLabel = (provider: ICompanyProvidersResponseDTO) => {
    if (provider.taxId && isCNPJ(provider.taxId)) {
      return `${provider.name} - [CNPJ: ${docMask(provider.taxId)}]`
    }
    return `${provider.name} - [CPF: ${provider.taxId}]`
  }

  return (
    <Box direction="column" gap={3} width="100%" padding={3}>
      <BackButton url="/traceability" />

      <Box gap={1} direction="column" width="100%">
        <Text>Escolha um fornecedor para verificar suas notas fiscais</Text>
        <Box maxWidth="500px" width="100%" flex={1}>
          <Autocomplete
            icon="search"
            placeholder="Fornecedor"
            options={providers}
            onChange={(_provider) =>
              handleProviderChange(_provider as ICompanyProvidersResponseDTO)
            }
            getOptionLabel={(option) =>
              getOptionLabel(option as ICompanyProvidersResponseDTO)
            }
            onFilterChange={(value) => setFilter(value)}
            value={provider}
            isAsync
          />
        </Box>
      </Box>
      <Box width="100%" gap={2} direction="column">
        {loading && (
          <Box width="100%" padding={3} justifyContent="center">
            <Spinner size="40px" />
          </Box>
        )}

        <InvoiceCodeTable provider={provider} />
      </Box>
    </Box>
  )
}

export const OriginInvoice = () => {
  return (
    <OriginInvoiceProvider>
      <OriginInvoiceComp />
    </OriginInvoiceProvider>
  )
}
